import { PUBLIC_LOCATION_STATES as s, PUBLIC_ONLINE_COURSE_STATES as a } from "@coast/utils";
import { R as r, A as o } from "./navigationData-tFNNVAXI.js";
const n = (e) => {
  const i = /* @__PURE__ */ new Set();
  return e.filter((l) => i.has(l.href) ? !1 : (i.add(l.href), !0));
}, t = [
  {
    label: "View all locations",
    href: "/locations"
  },
  ...s.map((e) => ({
    label: e.label,
    href: `/state/${e.slug}`
  }))
], c = a.flatMap(
  (e) => e.courses.map((i) => ({
    label: `${e.label} ${i.label}`,
    href: i.href
  }))
), f = [
  {
    label: "Book driving lessons",
    href: "/location-search"
  },
  {
    label: "Drivers Ed courses",
    href: "/courses"
  },
  ...r,
  {
    label: "Pricing",
    href: "/pricing"
  },
  {
    label: "Reviews",
    href: "/coastline-academy-driving-school-reviews"
  },
  {
    label: "Sell your school",
    href: "/article/selling-your-driving-school-to-coastline"
  }
], d = n([
  ...o,
  {
    label: "Affiliates",
    href: "/affiliate-signup"
  },
  {
    label: "Terms of Service",
    href: "/article/terms-of-service"
  },
  {
    label: "Privacy Notice",
    href: "/article/privacy-notice"
  },
  {
    label: "Privacy Choices",
    href: "/profile/privacy-choices"
  }
]), h = [
  {
    title: "Explore locations",
    description: "Find instructors and vehicles in your city.",
    links: t
  },
  {
    title: "Online courses",
    description: "Drivers Ed availability varies by state.",
    links: c
  },
  {
    title: "Student resources",
    description: "Tools to prep for permits, lessons, and the road test.",
    links: f
  },
  {
    title: "About Coastline",
    description: "Meet the team and partners moving driving forward.",
    links: d
  }
], S = "We're on a mission to eradicate car crashes by helping people become safe, confident drivers for life.", v = [
  {
    label: "California License E2115",
    href: "https://www.dmv.ca.gov/wasapp/olinq2/display.do?submitName=Display&ol=E2115~E~E2115~00"
  },
  {
    label: "Colorado Certificate 9906"
  },
  {
    label: "Texas Licenses C3371, C3371b, C3371c"
  },
  {
    label: "Las Vegas License #PRDS00051916"
  },
  {
    label: "Reno License #PRDS00051767"
  },
  {
    label: "Indianapolis, IN License PDF",
    href: "/l-assets/coastline_academy_indianapolis_license.pdf"
  },
  {
    label: "Valparaiso, IN License PDF",
    href: "/l-assets/coastline_academy_valparaiso_license.pdf"
  },
  {
    label: "Illinois License #9505"
  },
  {
    label: "Pennsylvania Reporting Code 300462730"
  },
  {
    label: "Washington License #25014847 and #25014866"
  }
];
export {
  S as F,
  v as S,
  h as a
};
